// @ts-nocheck

import { colors } from '@lmc/common/constants'
import type { Log } from '@lmc/ts-common'
import { EmptyState, NoDataIcon } from '@lmc/ui-kit'
import dayjs from 'dayjs'
import _ from 'lodash'
import type React from 'react'
import { LogTimelineRow } from '../LogTimelineRow'

interface PerDay {
  date: string
  logs: Log[]
}

export interface LogTimelineProps {
  logs: Log[]
  emptyHeading?: string
  isPDF?: boolean
  testId?: string
}

interface LogDayProps {
  perDay: PerDay
  isPDF?: boolean
  testId?: string
}

const LogDay = ({ perDay, isPDF, testId }: LogDayProps) => {
  const total = _.get(perDay, 'logs.length') || 0
  const Logs = _.sortBy(perDay.logs, (d) => -dayjs(d.timeLogged).toDate()).map(
    (log, index) => (
      <LogTimelineRow
        key={log.id}
        log={log}
        index={index}
        total={total}
        isPDF={isPDF}
        testId={testId}
      />
    )
  )

  return (
    <ul style={styles.logsList}>
      <li style={styles.logHeader}>
        <div style={styles.logDate}>
          {dayjs(perDay.date).format('ddd DD MMM')}
        </div>
      </li>
      {Logs}
    </ul>
  )
}

const LogTimeline: React.FC<LogTimelineProps> = ({ logs, isPDF, testId }) => {
  const baseId = testId || 'log-timeline'

  const groupByDay = (logs: Log[]) =>
    _.chain(logs)
      .sortBy((d) => dayjs(d.timeLogged).toDate(), 'desc')
      .reverse()
      .groupBy(({ timeLogged }) => dayjs(timeLogged).format('YYYY-MM-DD'))
      .map((group, date) => ({ date, logs: group }))
      .sortBy(({ date }) => -dayjs(date).valueOf())
      .value()

  const isEmpty = !logs || !logs.length
  const logsByDay = groupByDay(logs)

  return (
    <div style={styles.container} data-testid={baseId}>
      <div>
        {isEmpty ? (
          // @ts-ignore
          <EmptyState
            title="Shoot... no data to show you"
            description="No logs found"
            icon={<NoDataIcon />}
            data-testid={`${baseId}-empty`}
          />
        ) : (
          logsByDay.map((perDay, dayIndex) => (
            // eslint-disable-next-line react/no-array-index-key
            <LogDay
              key={perDay.date}
              perDay={perDay}
              isPDF={isPDF}
              testId={`${baseId}-day-${dayIndex}`}
            />
          ))
        )}
      </div>
    </div>
  )
}

const styles = {
  container: {
    minHeight: '50vh',
    margin: '30px 0 0 0'
  },
  logsList: {
    paddingLeft: 0,
    paddingBottom: 24,
    listStyleType: 'none'
  },
  logHeader: {
    paddingBottom: 12
  },
  logDate: {
    marginBottom: 0,
    marginTop: 12,
    fontSize: 20,
    fontWeight: 500,
    color: colors.darkgrey
    // fontWseight: 300,
    // opacity: 0.7,
  },
  divider: {
    height: 2,
    width: '100%'
  }
}

export default LogTimeline
